import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/rh/concursos/listar/form_edit'
import Head from '../../../../../components/head'


function EditarConcursosScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Concurso Público" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarConcursosScreen;